var data = `date,close,volume,open,high,low
2019/08/02,204.0200,40862120.0000,205.5300,206.4300,201.6300
2019/08/01,208.4300,54017920.0000,213.9000,218.0300,206.7435
2019/07/31,213.0400,69281360.0000,216.4200,221.3700,211.3000
2019/07/30,208.7800,33935720.0000,208.7600,210.1600,207.3100
2019/07/29,209.6800,21673390.0000,208.4600,210.6400,208.4400
2019/07/26,207.7400,17618870.0000,207.4800,209.7300,207.1400
2019/07/25,207.0200,13909560.0000,208.8900,209.2400,206.7300
2019/07/24,208.6700,14991570.0000,207.6700,209.1500,207.1700
2019/07/23,208.8400,18355210.0000,208.4600,208.9100,207.2900
2019/07/22,207.2200,22277930.0000,203.6500,207.2300,203.6100
2019/07/19,202.5900,20929310.0000,205.7900,206.5000,202.3600
2019/07/18,205.6600,18582160.0000,204.0000,205.8800,203.7000
2019/07/17,203.3500,14107450.0000,204.0500,205.0915,203.2700
2019/07/16,204.5000,16866820.0000,204.5900,206.1100,203.5000
2019/07/15,205.2100,16947420.0000,204.0900,205.8700,204.0000
2019/07/12,203.3000,17595210.0000,202.4500,204.0000,202.2000
2019/07/11,201.7500,20191840.0000,203.3100,204.3900,201.7100
2019/07/10,203.2300,17897140.0000,201.8500,203.7300,201.5600
2019/07/09,201.2400,20578020.0000,199.2000,201.5100,198.8100
2019/07/08,200.0200,25338630.0000,200.8100,201.4000,198.4100
2019/07/05,204.2300,17265520.0000,203.3500,205.0800,202.9000
2019/07/03,204.4100,11362050.0000,203.2800,204.4400,202.6901
2019/07/02,202.7300,16935220.0000,201.4100,203.1323,201.3600
2019/07/01,201.5500,27316740.0000,203.1700,204.4900,200.6500
2019/06/28,197.9200,31110640.0000,198.6800,199.4950,197.0500
2019/06/27,199.7400,20899720.0000,200.2900,201.5700,199.5700
2019/06/26,199.8000,26067510.0000,197.7700,200.9900,197.3500
2019/06/25,195.5700,21070330.0000,198.4300,199.2600,195.2900
2019/06/24,198.5800,18220420.0000,198.5400,200.1600,198.1700
2019/06/21,198.7800,47800590.0000,198.8000,200.8500,198.1500
2019/06/20,199.4600,21513990.0000,200.3700,200.6100,198.0300
2019/06/19,197.8700,21124240.0000,199.6800,199.8800,197.3100
2019/06/18,198.4500,26551000.0000,196.0500,200.2900,195.2100
2019/06/17,193.8900,14669140.0000,192.9000,194.9600,192.1700
2019/06/14,192.7400,18761470.0000,191.5450,193.5863,190.3000
2019/06/13,194.1500,21674630.0000,194.7000,196.7900,193.6000
2019/06/12,194.1900,18253190.0000,193.9500,195.9700,193.3850
2019/06/11,194.8100,26932880.0000,194.8600,196.0000,193.6000
2019/06/10,192.5800,26220850.0000,191.8100,195.3700,191.6200
2019/06/07,190.1500,30684390.0000,186.5100,191.9200,185.7700
2019/06/06,185.2200,22526310.0000,183.0800,185.4700,182.1489
2019/06/05,182.5400,29773430.0000,184.2800,184.9900,181.1400
2019/06/04,179.6400,30967960.0000,175.4400,179.8300,174.5200
2019/06/03,173.3000,40396070.0000,175.6000,177.9200,170.2700
2019/05/31,175.0700,27043580.0000,176.2300,177.9900,174.9900
2019/05/30,178.3000,21218410.0000,177.9500,179.2300,176.6700
2019/05/29,177.3800,28481170.0000,176.4200,179.3500,176.0000
2019/05/28,178.2300,27948160.0000,178.9200,180.5900,177.9100
2019/05/24,178.9700,23714690.0000,180.2000,182.1400,178.6200
2019/05/23,179.6600,36529740.0000,179.8000,180.5400,177.8100
2019/05/22,182.7800,29748560.0000,184.6600,185.7100,182.5500
2019/05/21,186.6000,28364850.0000,185.2200,188.0000,184.7000
2019/05/20,183.0900,38612290.0000,183.5200,184.3490,180.2839
2019/05/17,189.0000,32879090.0000,186.9300,190.9000,186.7600
2019/05/16,190.0800,33031360.0000,189.9100,192.4689,188.8400
2019/05/15,190.9200,26544720.0000,186.2700,191.7500,186.0200
2019/05/14,188.6600,36529680.0000,186.4100,189.7000,185.4100
2019/05/13,185.7200,57430620.0000,187.7100,189.4800,182.8500
2019/05/10,197.1800,41208710.0000,197.4190,198.8500,192.7700
2019/05/09,200.7200,34908610.0000,200.4000,201.6800,196.6600
2019/05/08,202.9000,26339500.0000,201.9000,205.3400,201.7500
2019/05/07,202.8600,38763700.0000,205.8800,207.4175,200.8250
2019/05/06,208.4800,32443110.0000,204.2900,208.8400,203.5000
2019/05/03,211.7500,20892380.0000,210.8900,211.8400,210.2300
2019/05/02,209.1500,31996320.0000,209.8400,212.6500,208.1300
2019/05/01,210.5200,64827330.0000,209.8800,215.3100,209.2300
2019/04/30,200.6700,45751160.0000,203.0600,203.4000,199.1100
2019/04/29,204.6100,22010360.0000,204.4000,205.9700,203.8600
2019/04/26,204.3000,18612770.0000,204.9000,205.0000,202.1200
2019/04/25,205.2800,18463850.0000,206.8300,207.7600,205.1200
2019/04/24,207.1600,17427570.0000,207.3600,208.4800,207.0500
2019/04/23,207.4800,23286380.0000,204.4300,207.7500,203.9000
2019/04/22,204.5300,17841920.0000,202.8300,204.9400,202.3400
2019/04/18,203.8600,24185530.0000,203.1200,204.1500,202.5200
2019/04/17,203.1300,28865310.0000,199.5400,203.3800,198.6100
2019/04/16,199.2500,25668330.0000,199.4600,201.3700,198.5600
2019/04/15,199.2300,17524150.0000,198.5800,199.8500,198.0100
2019/04/12,198.8700,27738580.0000,199.2000,200.1400,196.2100
2019/04/11,198.9500,20543190.0000,200.8500,201.0000,198.4431
2019/04/10,200.6200,21654750.0000,198.6800,200.7400,198.1800
2019/04/09,199.5000,35738280.0000,200.3200,202.8500,199.2300
2019/04/08,200.1000,25829880.0000,196.4200,200.2300,196.3400
2019/04/05,197.0000,18473070.0000,196.4500,197.1000,195.9300
2019/04/04,195.6900,19090050.0000,194.7900,196.3700,193.1400
2019/04/03,195.3500,23243160.0000,193.2500,196.5000,193.1500
2019/04/02,194.0200,22727370.0000,191.0900,194.4600,191.0500
2019/04/01,191.2400,27308200.0000,191.6400,191.6800,188.3800
2019/03/29,189.9500,23524830.0000,189.8300,190.0800,188.5400
2019/03/28,188.7200,20710390.0000,188.9500,189.5590,187.5300
2019/03/27,188.4700,29771210.0000,188.7500,189.7600,186.5500
2019/03/26,186.7900,49696100.0000,191.6640,192.8800,184.5800
2019/03/25,188.7400,43751810.0000,191.5100,191.9800,186.6000
2019/03/22,191.0500,42287640.0000,195.3400,197.6900,190.7800
2019/03/21,195.0900,50943120.0000,190.0200,196.3300,189.8100
2019/03/20,188.1600,31003380.0000,186.2300,189.4900,184.7300
2019/03/19,186.5300,31440300.0000,188.3500,188.9900,185.9200
2019/03/18,188.0200,26148590.0000,185.8000,188.3900,185.7900
2019/03/15,186.1200,39017490.0000,184.8500,187.3300,183.7400
2019/03/14,183.7300,23527660.0000,183.9000,184.1000,182.5600
2019/03/13,181.7100,30929740.0000,182.2500,183.3000,180.9200
2019/03/12,180.9100,32416800.0000,180.0000,182.6700,179.3700
2019/03/11,178.9000,31123000.0000,175.4900,179.1200,175.3500
2019/03/08,172.9100,23985960.0000,170.3200,173.0700,169.5000
2019/03/07,172.5000,24755470.0000,173.8700,174.4400,172.0200
2019/03/06,174.5200,20755140.0000,174.6700,175.4900,173.9400
2019/03/05,175.5300,19238480.0000,175.9400,176.0000,174.5400
2019/03/04,175.8500,27413060.0000,175.6900,177.7500,173.9700
2019/03/01,174.9700,25737560.0000,174.2800,175.1500,172.8900
2019/02/28,173.1500,27953810.0000,174.3200,174.9100,172.9200
2019/02/27,174.8700,27817640.0000,173.2100,175.0000,172.7300
2019/02/26,174.3300,16991610.0000,173.7100,175.3000,173.1732
2019/02/25,174.2300,21846400.0000,174.1600,175.8700,173.9500
2019/02/22,172.9700,18890250.0000,171.5800,173.0000,171.3800
2019/02/21,171.0600,17154540.0000,171.8000,172.3700,170.3000
2019/02/20,172.0300,25323890.0000,171.1900,173.3200,170.9900
2019/02/19,170.9300,18958570.0000,169.7100,171.4400,169.4900
2019/02/15,170.4200,24603320.0000,171.2500,171.7000,169.7500
2019/02/14,170.8000,21785180.0000,169.7100,171.2615,169.3800
2019/02/13,170.1800,22389660.0000,171.3900,172.4800,169.9200
2019/02/12,170.8900,22224400.0000,170.1000,171.0000,169.7000
2019/02/11,169.4300,20940020.0000,171.0500,171.2100,169.2500
2019/02/08,170.4100,23793830.0000,168.9900,170.6600,168.4200
2019/02/07,170.9400,31644240.0000,172.4000,173.9400,170.3400
2019/02/06,174.2400,28204640.0000,174.6500,175.5700,172.8531
2019/02/05,174.1800,36054570.0000,172.8600,175.0800,172.3501
2019/02/04,171.2500,31384720.0000,167.4100,171.6550,167.2800
2019/02/01,166.5200,32644590.0000,166.9600,168.9800,165.9300
2019/01/31,166.4400,40613260.0000,166.1100,169.0000,164.5600
2019/01/30,165.2500,60800480.0000,163.2500,166.1500,160.2300
2019/01/29,154.6800,39914850.0000,156.2500,158.1300,154.1100
2019/01/28,156.3000,26147280.0000,155.7900,156.3300,153.6600
2019/01/25,157.7600,33508960.0000,155.4800,158.1300,154.3200
2019/01/24,152.7000,25418110.0000,154.1100,154.4800,151.7400
2019/01/23,153.9200,23046560.0000,154.1500,155.1400,151.7000
2019/01/22,153.3000,30273990.0000,156.4100,156.7300,152.6200
2019/01/18,156.8200,33259460.0000,157.5000,157.8800,155.9806
2019/01/17,155.8600,29616190.0000,154.2000,157.6600,153.2600
2019/01/16,154.9400,30483120.0000,153.0800,155.8800,153.0000
2019/01/15,153.0700,28449940.0000,150.2700,153.3900,150.0500
2019/01/14,150.0000,32018540.0000,150.8500,151.2700,149.2200
2019/01/11,152.2900,26924630.0000,152.8800,153.7000,151.5100
2019/01/10,153.8000,35661200.0000,152.5000,153.9700,150.8600
2019/01/09,153.3100,45034370.0000,151.2900,154.5300,149.6300
2019/01/08,150.7500,40622910.0000,149.5600,151.8200,148.5200
2019/01/07,147.9300,54571440.0000,148.7000,148.8300,145.9000
2019/01/04,148.2600,57423650.0000,144.5300,148.5499,143.8000
2019/01/03,142.1900,91106840.0000,143.9800,145.7200,142.0000
2019/01/02,157.9200,35637070.0000,154.8900,158.8500,154.2300
2018/12/31,157.7400,34499390.0000,158.5300,159.3600,156.4800
2018/12/28,156.2300,41740600.0000,157.5000,158.5200,154.5500
2018/12/27,156.1500,51608850.0000,155.8400,156.7700,150.0700
2018/12/26,157.1700,58133850.0000,148.3000,157.2300,146.7200
2018/12/24,146.8300,37169230.0000,148.1500,151.5500,146.5900
2018/12/21,150.7300,95497900.0000,156.8600,158.1600,149.6300
2018/12/20,156.8300,64398230.0000,160.4000,162.1100,155.3000
2018/12/19,160.8900,47597670.0000,166.0000,167.4500,159.0900
2018/12/18,166.0700,33753490.0000,165.3800,167.5300,164.3900
2018/12/17,163.9400,43250420.0000,165.4500,168.3500,162.7300
2018/12/14,165.4800,40620360.0000,169.0000,169.0800,165.2800
2018/12/13,170.9500,31754210.0000,170.4900,172.5700,169.5500
2018/12/12,169.1000,35474680.0000,170.4000,171.9200,169.0200
2018/12/11,168.6300,45968040.0000,171.6600,171.7900,167.0000
2018/12/10,169.6000,61759000.0000,165.0000,170.0900,163.3300
2018/12/07,168.4900,41678680.0000,173.4900,174.4900,168.3000
2018/12/06,174.7200,42704910.0000,171.7600,174.7800,170.4200
2018/12/04,176.6900,41141250.0000,180.9500,182.3899,176.2700
2018/12/03,184.8200,40537700.0000,184.4600,184.9400,181.2100
2018/11/30,178.5800,39424260.0000,180.2900,180.3300,177.0300
2018/11/29,179.5500,41523580.0000,182.6600,182.8000,177.7000
2018/11/28,180.9400,45941750.0000,176.7300,181.2900,174.9300
2018/11/27,174.2400,41156140.0000,171.5100,174.7700,170.8800
2018/11/26,174.6200,44662320.0000,174.2400,174.9500,170.2600
2018/11/23,172.2900,23623970.0000,174.9400,176.5950,172.1000
2018/11/21,176.7800,31096240.0000,179.7300,180.2700,176.5500
2018/11/20,176.9800,67678680.0000,178.3700,181.4700,175.5100
2018/11/19,185.8600,41626820.0000,190.0000,190.7000,184.9900
2018/11/16,193.5300,36191330.0000,190.5000,194.9695,189.4600
2018/11/15,191.4100,46271660.0000,188.3900,191.9700,186.9000
2018/11/14,186.8000,60547340.0000,193.9000,194.4800,185.9300
2018/11/13,192.2300,46725710.0000,191.6300,197.1800,191.4501
2018/11/12,194.1700,50991030.0000,199.0000,199.8500,193.7900
2018/11/09,204.4700,34317760.0000,205.5500,206.0100,202.2500
2018/11/08,208.4900,25289270.0000,209.9800,210.1200,206.7500
2018/11/07,209.9500,33291640.0000,205.9700,210.0600,204.1300
2018/11/06,203.7700,31774720.0000,201.9200,204.7200,201.6900
2018/11/05,201.5900,66072170.0000,204.3000,204.3900,198.1700
2018/11/02,207.4800,91046560.0000,209.5500,213.6500,205.4300
2018/11/01,222.2200,52954070.0000,219.0500,222.3600,216.8100
2018/10/31,218.8600,38016810.0000,216.8800,220.4500,216.6200
2018/10/30,213.3000,36487930.0000,211.1500,215.1800,209.2700
2018/10/29,212.2400,45713690.0000,219.1900,219.6900,206.0900
2018/10/26,216.3000,47191700.0000,215.9000,220.1900,212.6700
2018/10/25,219.8000,29027340.0000,217.7100,221.3800,216.7500
2018/10/24,215.0900,39992120.0000,222.6000,224.2300,214.5400
2018/10/23,222.7300,38681170.0000,215.8300,223.2500,214.7000
2018/10/22,220.6500,28751540.0000,219.7900,223.3600,218.9400
2018/10/19,219.3100,32874330.0000,218.0600,221.2600,217.4300
2018/10/18,216.0200,32389280.0000,217.8600,219.7400,213.0000
2018/10/17,221.1900,22692880.0000,222.3000,222.6400,219.3400
2018/10/16,222.1500,28802550.0000,218.9300,222.9900,216.7627
2018/10/15,217.3600,30280450.0000,221.1600,221.8300,217.2700
2018/10/12,222.1100,39494770.0000,220.4200,222.8800,216.8400
2018/10/11,214.4500,52902320.0000,214.5200,219.5000,212.3200
2018/10/10,216.3600,41084070.0000,225.4600,226.3500,216.0500
2018/10/09,226.8700,26656630.0000,223.6400,227.2700,222.2462
2018/10/08,223.7700,28784550.0000,222.2100,224.8000,220.2000
2018/10/05,224.2900,33507770.0000,227.9600,228.4100,220.5800
2018/10/04,227.9900,31961120.0000,230.7800,232.3500,226.7300
2018/10/03,232.0700,28540490.0000,230.0500,233.4700,229.7800
2018/10/02,229.2800,24435010.0000,227.2500,230.0000,226.6300
2018/10/01,227.2600,23171020.0000,227.9500,229.4200,226.3500
2018/09/28,225.7400,22560440.0000,224.7900,225.8400,224.0200
2018/09/27,224.9500,29729270.0000,223.8200,226.4400,223.5400
2018/09/26,220.4200,23430370.0000,221.0000,223.7500,219.7600
2018/09/25,222.1900,22811140.0000,219.7500,222.8200,219.7000
2018/09/24,220.7900,27581270.0000,216.8200,221.2600,216.6300
2018/09/21,217.6600,95584080.0000,220.7800,221.3600,217.2900
2018/09/20,220.0300,26388050.0000,220.2400,222.2800,219.1500
2018/09/19,218.3700,26869880.0000,218.5000,219.6200,215.3000
2018/09/18,218.2400,31495630.0000,217.7900,221.8500,217.1200
2018/09/17,217.8800,36810120.0000,222.1500,222.9500,217.2700
2018/09/14,223.8400,31801970.0000,225.7500,226.8400,222.5220
2018/09/13,226.4100,41411350.0000,223.5200,228.3500,222.5700
2018/09/12,221.0700,49118510.0000,224.9400,225.0000,219.8400
2018/09/11,223.8500,35644510.0000,218.0100,224.2990,216.5600
2018/09/10,218.3300,39194720.0000,220.9500,221.8500,216.4700
2018/09/07,221.3000,37418910.0000,221.8500,225.3700,220.7100
2018/09/06,223.1000,34121240.0000,226.2300,227.3500,221.3000
2018/09/05,226.8700,33290830.0000,228.9900,229.6700,225.1000
2018/09/04,228.3600,27363960.0000,228.4100,229.1800,226.6300
2018/08/31,227.6300,43177540.0000,226.5100,228.8700,226.0000
2018/08/30,225.0300,48696960.0000,223.2500,228.2600,222.4000
2018/08/29,222.9800,27074260.0000,220.1500,223.4900,219.4100
2018/08/28,219.7000,22751390.0000,219.0100,220.5400,218.9200
2018/08/27,217.9400,20400770.0000,217.1500,218.7400,216.3300
2018/08/24,216.1600,18457720.0000,216.6000,216.9000,215.1100
2018/08/23,215.4900,18505780.0000,214.6500,217.0500,214.6000
2018/08/22,215.0500,18965930.0000,214.1000,216.3600,213.8400
2018/08/21,215.0400,25682700.0000,216.8000,217.1900,214.0250
2018/08/20,215.4600,30149410.0000,218.1000,219.1800,215.1100
2018/08/17,217.5800,35034410.0000,213.4400,217.9500,213.1600
2018/08/16,213.3200,27595310.0000,211.7500,213.8121,211.4700
2018/08/15,210.2400,28595230.0000,209.2200,210.7400,208.3300
2018/08/14,209.7500,20679270.0000,210.1550,210.5600,208.2600
2018/08/13,208.8700,25864510.0000,207.7000,210.9520,207.7000
2018/08/10,207.5300,24592460.0000,207.3600,209.1000,206.6700
2018/08/09,208.8800,23389530.0000,207.2800,209.7800,207.2000
2018/08/08,207.2500,22493750.0000,206.0500,207.8100,204.5200
2018/08/07,207.1100,25525650.0000,209.3200,209.5000,206.7600
2018/08/06,209.0700,25396100.0000,208.0000,209.2500,207.0700
2018/08/03,207.9900,33408050.0000,207.0300,208.7400,205.4803
2018/08/02,207.3900,62317430.0000,200.5800,208.3800,200.3500`

export default data;